<div>
  <h1>Free Cancellation</h1>
  <h1>Pre Booking Discount</h1>
</div>